import { parseEventDateValue } from 'shared/helpers/DateHelper';

const minMaxFromAllocations = allocations => {
  if (!allocations?.length) return null;

  const startMs = allocations
    .map(a => (a?.start_at ? new Date(a.start_at).getTime() : null))
    .filter(v => v != null && !Number.isNaN(v));
  const endMs = allocations
    .map(a => (a?.end_at ? new Date(a.end_at).getTime() : null))
    .filter(v => v != null && !Number.isNaN(v));

  if (startMs.length === 0) return null;

  const start = new Date(Math.min(...startMs));
  const end = endMs.length > 0 ? new Date(Math.max(...endMs)) : null;

  return { start, end };
};

/** All event allocations are independent slots (legacy nested rows still flattened). */
export const getLeafAllocations = allocations => {
  if (!allocations?.length) return [];

  const leaves = [];
  const seen = new Set();

  allocations.forEach(alloc => {
    if (!alloc?.id || seen.has(alloc.id)) return;

    if (alloc.sub_allocations?.length) {
      alloc.sub_allocations.forEach(sub => {
        if (sub?.id && !seen.has(sub.id)) {
          seen.add(sub.id);
          leaves.push(sub);
        }
      });
      return;
    }

    seen.add(alloc.id);
    leaves.push(alloc);
  });

  return leaves;
};

/**
 * Single source of truth for event date/time range across list, show, and kanban views.
 * Prefers live allocation timestamps over cached API start_date/end_date.
 */
export const getEventDateRange = event => {
  if (!event) return null;

  const allocations = event.allocations || [];
  const fromLeaf = minMaxFromAllocations(getLeafAllocations(allocations));
  if (fromLeaf) return fromLeaf;

  const fromAllAllocations = minMaxFromAllocations(allocations);
  if (fromAllAllocations) return fromAllAllocations;

  const fromAllocatedResources = minMaxFromAllocations(
    event.allocated_resources
  );
  if (fromAllocatedResources) return fromAllocatedResources;

  const start = parseEventDateValue(event.start_date);
  if (start) {
    const end = parseEventDateValue(event.end_date);
    return { start, end };
  }

  return null;
};
